var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 77.527c-28.554 59.928-54.586 129.729-55.912 171.23 8.106 8.904 15.512 20.237 21.314 31.84 6.48 12.959 11.159 25.504 11.159 36.714v7.162l-6.946 1.736c-66.268 16.567-117.525 16.69-168.181-.195l-6.272-2.092v-6.611c0-15.216-1.409-46.505 15.164-67.383a30.878 30.878 0 0 0-4.385-6.205c-4.186-4.627-10.398-9.935-17.129-14.743-6.73-4.807-14.012-9.164-20.302-12.193-1.295-.623-2.295-.892-3.51-1.38.946 26.658 4.726 70.82 11.693 112.624 2.773 16.637 6.043 32.722 9.715 46.89 151.612 14.462 275.572 14.462 427.184 0 3.672-14.168 6.942-30.253 9.715-46.89 6.967-41.803 10.747-85.966 11.693-112.625-1.215.489-2.215.758-3.51 1.381-6.29 3.029-13.572 7.386-20.303 12.193-6.73 4.808-12.942 10.116-17.128 14.743a31.68 31.68 0 0 0-4.32 6.088c17.421 20.991 15.099 52.656 15.099 67.5v6.61l-6.272 2.093c-50.656 16.885-101.913 16.762-168.181.195l-6.946-1.736v-7.162c0-11.21 4.68-23.755 11.159-36.713 5.802-11.604 13.208-22.937 21.314-31.84-1.326-41.502-27.358-111.303-55.912-171.23zm0 31.963 42.541 127.623L256 300.926l-42.541-63.813 34.002-102.008L256 109.49zm0 56.922-22.682 68.043 7.621 11.43c5.09-24.4 12.37-47.622 22.932-55.86L256 166.412zM47.852 393.508c5.502 16.226 12.645 26.698 15.904 29.09 128.174 15.834 256.314 15.834 384.488 0 3.259-2.392 10.402-12.865 15.904-29.09-146.943 13.646-269.353 13.646-416.296 0z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.3b369c3a7d1dd5eb7bbe1a6c2d4f2dc8.svg";
export { ForwardRef as ReactComponent };